// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2680":"c1e35734739bc181","3185":"6ab8fa6648cd90de"}[chunkId] + ".css";
};